// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"fb3258e4","864":"1eb5441c"}[chunkId] + ".chunk.js";
};